import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthBackground from '../../components/AuthBackground';
import ScreenContainer from '../../components/ScreenContainer';
import TopBar from '../../components/TopBar';
import Heading from '../../components/Heading';
import Text from '../../components/Text';
import TextField from '../../components/TextField';
import Button from '../../components/Button';
import Toast from '../../components/Toast';
import api from '../../api';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await api.post('/accounts/auth/send-otp/', { email });
      
      if (response.data.success) {
        setToast({ type: 'success', message: 'OTP sent to your email!' });
        setTimeout(() => {
          navigate('/auth/verify-code', { state: { email } });
        }, 1500);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to send OTP. Please try again.';
      setToast({ type: 'error', message: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AuthBackground />
      <ScreenContainer>
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <TopBar 
            title="Forgot password" 
            onBack={() => navigate('/auth')}
          />
          <div className="mb-6">
            <Heading size="lg" className="mb-3">Reset Your Password</Heading>
            <Text>Please enter your email to reset the password</Text>
          </div>
          <div className="space-y-4">
            <TextField
              placeholder="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Button 
              fullWidth
              onClick={handleSubmit}
              loading={loading}
              disabled={!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
            >
              Send OTP
            </Button>
          </div>
        </div>
      </ScreenContainer>
      <Toast 
        message={toast?.message} 
        type={toast?.type}
        onClose={() => setToast(null)}
      />
    </>
  );
};

export default ForgotPassword;